import(/* webpackMode: "eager", webpackExports: ["DynamicOrgSwitcher"] */ "/vercel/path0/components/DynamicOrgSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkspaceSidebarHeader"] */ "/vercel/path0/components/workspace-sidebar/header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/workspace-sidebar/menu-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/context/LoadingProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserButton"] */ "/vercel/path0/node_modules/@daveyplate/better-auth-ui/dist/index.js");
